import {Component, Input} from '@angular/core';
import {BrAbendschauWetterbericht} from '../../../../../../../model/vorhersagen/br-wetterbericht';

@Component({
  selector: 'app-br-abendschauwetter-bericht',
  templateUrl: './br-abendschauwetter-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class BrAbendschauwetterBerichtComponent {
  @Input() abendschauWetterbericht: BrAbendschauWetterbericht;
}
